
import { useRef, useState , useEffect, Fragment } from "react";
import Config from "../../Config";
import InputText from "../../helpers/InputText";
import InputTextArea from "../../helpers/InputTextArea";
import InputKidsMulti from "../../helpers/InputKidsMulti";
import InputParentsMulti from "../../helpers/InputParentsMulti";
import InputUploader from "../../helpers/InputUploader";

import back from "../../back.png";
import BkTextEditor from "../../BkTextEditor/BkTextEditor";
import InputEmpsMulti from "../../helpers/InputEmpsMulti";
import InputCombo from "../../helpers/InputCombo";

function MsgNew(props)
{
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);

 
    var defRecv = new Array();
    var defRecvTitle = "";

    if(props.recv != null) defRecv = props.recv;
    if(props.recv_title != null) defRecvTitle = props.recv_title;


    const [errTab, setErrTab] = useState([]);  //z info od serwera..
    const [row, setRow] = useState({

        typ: 'email', //sms

        odbiorcy: defRecv,
        odbiorcy_def: defRecv,

        odbiorcy2: [],
        odbiorcy2_def: [],

        temat: defRecvTitle,
        tresc:"",
        files: [],
    });

    var tmpFiles = [];

    var [clearFlag, setClearFlag] = useState(1);





    const [checked, setChecked] = useState(false);
    const handleChange = () => {
        setChecked(!checked);
      };


      
      const onParentsSelected = (tab) => {

        //    console.log("Odbiorcy", tab);

            setRow( {...row, ["odbiorcy"]:tab  } );
      }


         
      const onEmpsSelected = (tab) => {

        //    console.log("Odbiorcy", tab);

            setRow( {...row, ["odbiorcy2"]:tab  } );
      }


    const valChangeListener = (filedName, val, correct, msg) => { 
        //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);      


      
        setRow( {...row, [filedName]:val,  [filedName+"_valid"]:correct  } );         
    }



    
    const goNextNew = () => {
        console.log("goNext");
        goSend();
    }

    const valChecker = (fields) => {

        var allValid = true;

              
        Object.entries(fields).forEach(function(entry) {

            var xKey    = entry[0];
            var xValue  = entry[1];

            var xValidName = xKey + "_valid";

            if(fields[xValidName] == false)
            {
                allValid = false;
                console.log("Error field: " + xKey);
            }
            
          });
        
          return allValid;

    }



    const goClear = () => {


        setRow({
            odbiorcy: [],    
            odbiorcy2: [],    
            temat:"",
            tresc:"",
            files: [],
        });

        setClearFlag( clearFlag +1 );
    }


    const goSend = ()  => {


        if(row.odbiorcy.length < 1 && row.odbiorcy2.length < 1)
        {
            props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , "Wybierz odbiorców wiadomości"  ,  "ok"  ,null); 
            return;
        }


        if(!valChecker(row))
           {
                props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , props.userData.dic.dlg_gocorrect  ,  "ok"  ,null); 
                return;
           }


 

        props.mainView.setProgress(-2);

    
        fetch( Config.master + '/rest_v1_msg,send', {  //bo pliki sa wyslane do mastera..
            method: 'POST', 
            body: JSON.stringify(row), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })         
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        props.mainView.setProgress(-1);  
                        if(res.status == 'OK') {
                                
                 
                            goClear();

                            props.mainView.showDialog( "Sukces", "Wysłano wiadomości: " + res.result , "ok" ,  (respx) => {


                                document.location.reload(true);

                            } );  
 
 

                        } 

                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });



    }


    const completeUpload = (fileName, crypt) => {

        console.log("completeUpload: " + fileName + " " + crypt);
       // goParse(crypt);

  
         tmpFiles.push({
            fileName: fileName,
            crypt: crypt
        });
 
        setRow(  {...row, ["files"]: tmpFiles  } );
    }

    

    const goDeleteAttach = (e) => {

        var crypt  =  e.target.getAttribute("atr-crypt");
        var typ    =  e.target.getAttribute("atr-typ");
        var typId  =  e.target.getAttribute("atr-typId");

        
        var req = {
            id: -1,
            crypt: crypt,
            typ: typ,
            typ_id: typId,
        }


        props.mainView.setProgress(-2);

    
        fetch( Config.url + '/rest_v1,del_by', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })         
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        props.mainView.setProgress(-1);  
                        if(res.status == 'OK') {
                                
               
                           var newTmp = new Array();

                           for(var k=0; k<row.files.length; k++)
                           {                              
                                if(row.files[k].crypt == crypt  ) continue; 
                                newTmp.push( row.files[k] );
                           }

                           setRow({...row, ["files"]: newTmp  } );
                           

                        } 

                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });



    }








   if(refreshView != props.userData.refreshView)
    {         
        setRefreshView( props.userData.refreshView);
        goClear();
    }

 


 

    return <div className="view_content">
 
                {
                    props.goBack != null &&
                    <img src={back} onClick={props.goBack} className="back_img" title="wstecz"/>
                }

       

                <form className="eForm bg_center">


                                   <div className="form_tab_title">Odbiorca (Rodzice)</div>

                                   {
                                     row.odbiorcy_def != null && row.odbiorcy_def != undefined && row.odbiorcy_def.length > 0 && 
                                     <div className="form_tab">  
                                          {
                                            row.odbiorcy_def.map( (r, inx) => {
                                                return <div>
                                                    {r.nazwa}  
                                                </div>
                                            } )
                                          }
                                     </div>
                                   } 

                                    {
                                      (row.odbiorcy_def == null || row.odbiorcy_def.length == 0) && 
                                     <div className="form_tab">               
                                                <InputParentsMulti  clearFlag={clearFlag}  userData={props.userData}  mainView={props.mainView} recv={row.odbiorcy_def} onParentsSelected={onParentsSelected}   />  
                                    </div>
                                   } 


                                  {
                                    props.userData.type == "DYREKTOR" && 
                                    <Fragment>
                                            <div className="form_tab_title">Odbiorca (Pracownicy)</div>
                                            <div className="form_tab">               
                                                        <InputEmpsMulti  clearFlag={clearFlag}  userData={props.userData}  mainView={props.mainView} recv={row.odbiorcy2_def} onParentsSelected={onEmpsSelected}   />  
                                            </div>
                                    </Fragment>
                                  }
                                   
                                   
                                   

                                 
                                   <div className="form_control">      
                                        <div className="fieldName">Rodzaj wiadomości</div>
                                        <InputCombo  items={ [  {v:'email', title:'E-mail / Wiadomość w aplikacji'}, {v:'e_mail_sms', title:'E-mail / Wiadomość w aplikacji oraz SMS* (płatne) '} ]  }  value={row.typ} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="typ" placeholder={":"} className='' req='1'   />
                                    </div>

                                   <div className="form_control">      
                                        <div className="fieldName">Temat wiadomości</div>
                                        <InputText   userData={props.userData} value={row.temat} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="temat" placeholder={"Temat:"} className='w400' req='1'   />
                                    </div>

                                    {
                                        row.typ == "e_mail_sms" &&
                                        <Fragment>
                                            <div>                                         
                                               *Uwaga: w opcji SMS zalecana ilość znaków w treśći wiadomości to 140. Stawka za jednego wysłanego sms została określona w umowie.  
                                               <br/>&nbsp; <br/>
                                            </div>
                                        </Fragment>
                                    }

                                    <div className="form_split">     </div> 

                                    <div className="form_control p95">      
                                        <div className="fieldName">Treść</div>
 
                                        <BkTextEditor  name="tresc" valChange={valChangeListener}  value="" mini="1"  req='1'  /> 
                                    </div>


                                    <div className="form_split">     </div> 

                                    <div>
                                        Załączniki ({row.files.length}): 
                                        {
                                            row.files.map( (ff, ix) => {
                                                return <span>
                                                         <b>  {ff.fileName} <sup className="link_color" atr-crypt={ff.crypt} atr-typ="none" atr-typId="-1" onClick={goDeleteAttach}>usuń</sup> </b> &nbsp; &nbsp;
                                                </span>
                                            }   )
                                        }
                                    </div>

                                    <br/>

                                    <div className="form_control">
                                           
                                           <InputUploader   userData={props.userData}  typ="none" typId={"-1"} remove="0" completeUpload={completeUpload} title={ "-dodaj załącznik-" } max_files="10" ext="*/*" />                    
                                                       
                                    </div>

   

                                  <div className="form_split">     </div> 
                                  <br/>
                                  <div className="form_split">     </div> 

                                    
                                <div className="form_split"></div>

                                <div className="form_btn">
                                        <div className="btn" onClick={goSend}>Wyślij</div>                                     
                                </div>

                </form>

 
    </div>
}

export default MsgNew;